import Heart from '~/icons/HeartWithBorder';
import {
  Overlay,
  DetailsGrid,
  DetailsWrapper,
  LowerSectionWrapper,
  Price,
  TrimAndMileage,
  Wrapper,
  YearMakeModel,
  UpperSection
} from './VehicleTile.styles';

const VehicleTileSkeleton = () => (
  <Wrapper className="m-auto blur m:m-0" data-qa="vehicle-tile">
    <UpperSection>
      <Overlay className="flex-col items-end">
        <Heart className="pointer-events-auto m-12 h-[18px] w-[20px]" />
      </Overlay>
    </UpperSection>
    <DetailsWrapper>
      <DetailsGrid>
        <div className="text-grey-3 tl-label-xs">Carvana Certified</div>
        <YearMakeModel>2000 Make Model</YearMakeModel>
        <TrimAndMileage>
          Trim <span className="px-4">•</span> 1,000 miles
        </TrimAndMileage>
      </DetailsGrid>
      <div className="mb-12 flex items-end">
        <Price>$00,000</Price>
      </div>
      <div>
        <div className="border-b border-grey-2" />
        <LowerSectionWrapper />
      </div>
    </DetailsWrapper>
  </Wrapper>
);

export default VehicleTileSkeleton;
